"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtSecretUpdateError = exports.JwtSecretUpdateProgress = exports.JwtSecretUpdateStatus = exports.ProjectEvents = void 0;
var ProjectEvents;
(function (ProjectEvents) {
    ProjectEvents["ProjectPaused"] = "project.paused";
    ProjectEvents["ProjectRestored"] = "project.restored";
    ProjectEvents["ProjectRestoredFromLogicalBackup"] = "project.restored_from_logical_backup";
    ProjectEvents["ProjectRestoredFromPitr"] = "project.restored_from_pitr";
    ProjectEvents["ProjectFailedRestorationFromPitr"] = "project.failed_restoration_from_pitr";
    ProjectEvents["ProjectPendingShutdown"] = "project.pending_shutdown_notification";
    ProjectEvents["ProjectShutdownEligible"] = "project.shutdown_eligible";
    ProjectEvents["ProjectJwtSecretUpdateStatusChange"] = "project.jwt_secret_update_status_change";
    ProjectEvents["ProjectServiceConfigUpdate"] = "project.service_config_update";
    ProjectEvents["ProjectSansKpsMigrationInitiated"] = "project.sans_kps_migration_initiated";
    ProjectEvents["ProjectSansKpsMigrationCompleted"] = "project.sans_kps_migration_completed";
    ProjectEvents["PostgresqlRestart"] = "postgresql.restart";
})(ProjectEvents = exports.ProjectEvents || (exports.ProjectEvents = {}));
var JwtSecretUpdateStatus;
(function (JwtSecretUpdateStatus) {
    JwtSecretUpdateStatus[JwtSecretUpdateStatus["Updating"] = 0] = "Updating";
    JwtSecretUpdateStatus[JwtSecretUpdateStatus["Updated"] = 1] = "Updated";
    JwtSecretUpdateStatus[JwtSecretUpdateStatus["Failed"] = 2] = "Failed";
})(JwtSecretUpdateStatus = exports.JwtSecretUpdateStatus || (exports.JwtSecretUpdateStatus = {}));
var JwtSecretUpdateProgress;
(function (JwtSecretUpdateProgress) {
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["Started"] = 0] = "Started";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["RestartedPostgreSQL"] = 1] = "RestartedPostgreSQL";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["UpdatedAPIServicesConfiguration"] = 2] = "UpdatedAPIServicesConfiguration";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["RestartedAPIServices"] = 3] = "RestartedAPIServices";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["UpdatedDatabaseAdminAPIConfiguration"] = 4] = "UpdatedDatabaseAdminAPIConfiguration";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["UpdatedAPIGatewayConfiguration"] = 5] = "UpdatedAPIGatewayConfiguration";
})(JwtSecretUpdateProgress = exports.JwtSecretUpdateProgress || (exports.JwtSecretUpdateProgress = {}));
var JwtSecretUpdateError;
(function (JwtSecretUpdateError) {
    JwtSecretUpdateError[JwtSecretUpdateError["PostgreSQLRestartFailed"] = 0] = "PostgreSQLRestartFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["APIServicesConfigurationUpdateFailed"] = 1] = "APIServicesConfigurationUpdateFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["APIServicesRestartFailed"] = 2] = "APIServicesRestartFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["DatabaseAdminAPIConfigurationUpdateFailed"] = 3] = "DatabaseAdminAPIConfigurationUpdateFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["SupabaseAPIKeyUpdateFailed"] = 4] = "SupabaseAPIKeyUpdateFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["APIGatewayUpdateFailed"] = 5] = "APIGatewayUpdateFailed";
})(JwtSecretUpdateError = exports.JwtSecretUpdateError || (exports.JwtSecretUpdateError = {}));
